import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LogisticsTopBar',
  props: {
    title: null,
    subtitle: { default: '' },
    showBackButton: { type: Boolean, default: false },
    showNextButton: { type: Boolean, default: true },
    currentStep: { default: null },
    showAlternativeButton: { type: Boolean, default: false },
    canGoBack: { type: Boolean, default: true }
  },
  emits: ["back", "next", "createDeliveryList"],
  setup(__props: any) {

const props = __props as { title: string, subtitle: string, showBackButton: boolean, showNextButton: boolean, currentStep: any, showAlternativeButton: boolean, canGoBack: boolean };





return { __sfc: true,props }
}

})